export default "__VITE_ASSET__BRDs3HAe__"